import { render, staticRenderFns } from "./EqualWeight.vue?vue&type=template&id=231b8556&scoped=true&"
import script from "./EqualWeight.vue?vue&type=script&lang=js&"
export * from "./EqualWeight.vue?vue&type=script&lang=js&"
import style0 from "./EqualWeight.vue?vue&type=style&index=0&id=231b8556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b8556",
  null
  
)

export default component.exports